<template>
  <div class="f-subsidyreview">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="subsidyAudit:audit">
        <el-button type="primary" class="fun-btn mr10" @click="batchAudit" v-if="isSelection"> + 批量审核</el-button>
      </auth-button>
    </div>
    <Table
      :loading="loading"
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      :selection="isSelection"
      @getSelectData="getSelectData"
    >
      <template #paymentOrderId="{ row }">{{ row.paymentOrderId }}</template>
      <template #discountName="{ row }">{{ row.discountName }}</template>
      <template #storeName="{ row }">{{ row.storeName }}</template>
      <template #goodsOrderAmount="{ row }">{{ row.goodsOrderAmount }}</template>
      <template #discountAmount="{ row }">{{ row.discountAmount }}</template>
      <template #actualAmount="{ row }">{{ row.actualAmount }}</template>
      <template #operationTime="{ row }">{{ row.operationTime ? $moment(row.operationTime).format('YYYY/MM/DD HH:mm:ss') : '---'  }}</template>
      <template #auditStatus="{ row }">
        <div v-if="row.auditStatus=='Approved'" class="statusGreen">
            <span>已审核</span>
        </div>
        <div v-else-if="row.auditStatus=='Review'" class="statusBlue">
            <span>待审核</span>
        </div>
        <div v-else class="statusGreen">
            <span>无需审核</span>
        </div>
      </template>
        <template #operation="{ scope }">     
        <auth-button auth="subsidyAudit:audit">
          <el-button type="text" @click="audit(scope.row)">审核</el-button>
        </auth-button>
      </template>
     
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import Search from "@/components/Search/index"
import Table from "@/components/Table/index"
import { api_getStoreSubsidyData,api_postStoreSubsidyAudit} from '@/api/finance'
import tableList from '@/mixins/tableList'
export default {
  name: "fSubsidyreview",
  mixins: [tableList],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      form: {
        auditStatus:'Review'
      },
      isSelection:false,
      selection:[],
      renderData: [
        {
          label: "核销店铺",
          placeholder: "请输入核销店铺",
          type: "choose-store",
          key: "storeIds",
        },
        {
          label: "券名称",
          placeholder: "请选择券名称",
          type: "input",
          key: "discountName",
        },
        {
          label: "状态",
          placeholder: "请选择状态",
          type: "select",
          key: "auditStatus",
          option: [
            {
              label:'已审核',
              value:'Approved'
            },
            {
              label:'待审核',
              value:'Review'
            },
            {
              label:'无需审核',
              value:'NoNeedReview'
            }
          ]
        }
      ],
      tableThData: [
        { prop: "paymentOrderId", label: "订单号", minWidth: "120", },
        { prop: "discountName", label: "券名称", minWidth: "120", },
        { prop: "storeName", label: "核销店铺", minWidth: "120", },
        { prop: "goodsOrderAmount", label: "订单金额", minWidth: "120", },
        { prop: "discountAmount", label: "核销金额", minWidth: "120", },
        { prop: "actualAmount", label: "应补贴金额", minWidth: "120", },
        { prop: "operationTime", label: "核销时间", minWidth: "120", },
        { prop: "auditStatus", label: "状态", minWidth: "80", },
        { prop: "operation", label: "操作", minWidth: "80", },
      ],
    };
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.auditStatus=='Review'?this.isSelection = true:this.isSelection = false
      if(!this.isSelection&&this.tableThData[this.tableThData.length-1].prop == 'operation'){
        this.tableThData.pop()
      }
      if(this.isSelection&&this.tableThData[this.tableThData.length-1].prop != 'operation'){
        this.tableThData.push({ prop: "operation",label: "操作", minWidth: "80"})
      }
      console.log(this.tableTrData)
      try {
      const data = await api_getStoreSubsidyData(params)
      this.tableTrData = data.data.list || []
      this.total = data.data.count
      this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
      // 禁用选项
    checkSelectable_all(row) {
      return true
    },
    //批量审核
    batchAudit(){
    if (this.selection.length > 0) {
        let idList = this.selection.map((item)=>{
            return item.id
        })
        let params = {
          ids:[...idList],
          action:'pass'
        }
        this.$baseConfirm(
        '是否审核订单营销补贴款?',
        { title: '提示', type: 'warning', },
        async () => {
          await api_postStoreSubsidyAudit(params)
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
      }else{
        this.$baseMessage('请选择需要审核的数据', 'error')
      }
    },
    // 点击审核按钮
    audit(row) {
        let params = {
          ids:[row.id],
          action:'pass'
        }
        this.$baseConfirm(
        '是否审核订单营销补贴款?',
        { title: '提示', type: 'warning', },
        async () => {
          await api_postStoreSubsidyAudit(params)
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
        )
    },
 
    getSelectData (selection) {
      this.selection = selection
    },
  },
  computed: {},
  watch: {
  }
};
</script>
<style lang="scss" scoped>
.f-subsidyreview {
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .fun-btn-box {
    margin-top: 20px;
  }
  .level-update, .integral-update{
    margin-top: 22px;
    ::v-deep{
      .el-radio__label{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
      .el-radio__input.is-checked + .el-radio__label{
        color: #05C8AF;
      }
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
        .tips{
          font-size: 16px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-left: 20px
        }
      }
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  .add-label{
    margin-top: 22px;
    ::v-deep{
      .el-form{
        margin-top: 33px;
        .el-form-item__label{
          color: #333;
          font-size: 16px;
        }
        .el-input{
          border-radius: 2px;
          font-size: 16px;
          .el-input__inner{
            background: #F2F3F5;
            border: 0;
          }
          .el-input__inner:focus{
            background: #fff;
            border: 1px solid #05C8AF;
          }
        }
        .el-input.is-focus{
          .el-input__inner{
            background: #fff;
          }
        }
      }
    }
    .el-select{
      width: 100%;
    }
    .button-div{
      overflow: hidden;
      float: right;
      margin-top: 33px;
      button{
        border: 0;
        width: 110px;
        height: 40px;
        border-radius: 2px;
        font-size: 16px;
      }
      .cancel{
        background: #F2F3F5;
        color: #666666;
      }
    }
  }
  ::v-deep{
    .Dialog{
      .content{
        min-height: 280px;
      }
    }
  }
}
 .statusBlue {
    position: relative;
    padding-left: 15px;
    span::before{
    content: "";
    display: block;
    width:4px;
    height:4px;
    background-color: #3775FF;
    position: absolute;
    left: 0;
    top:10px;
    border-radius: 50%;
    }
  }
.statusGreen {
    position: relative;
    padding-left: 15px;
    span::before{
    content: "";
    display: block;
    width:4px;
    height:4px;
    background-color: #05C8AF;
    position: absolute;
    left: 0;
    top:10px;
    border-radius: 50%;
 }
}
</style>
